import { createStyles } from 'antd-style'

export const useWechatQrcodeStyles = createStyles(
  ({ token }, { bordered }: { bordered?: boolean }) => ({
    container: {
      padding: token.paddingXXS,
      backgroundColor: token.colorWhite,
      borderRadius: token.borderRadiusLG,
      border: bordered
        ? `${token.lineWidth}px ${token.lineType} ${token.colorSplit}`
        : undefined,
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    },
    mask: {
      position: 'absolute',
      insetBlockStart: 0,
      insetInlineStart: 0,
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      color: token.colorText,
      lineHeight: token.lineHeight,
      background: 'rgba(255, 255, 255, 0.96)',
      textAlign: 'center'
    },
    qrcode: {
      height: '100%',
      width: '100%'
    }
  })
)
